import { combineReducers } from 'redux';

import customers from './customers/reducer';
import customer from './customer/reducer';
import auth from './auth/reducer';
import user from './user/reducer';
import modal from './modal/reducer';


export const rootReducer = combineReducers({
  user,
  auth,
  customers,
  customer,
  modal
});



// WEBPACK FOOTER //
// ./src/store/combaineReducers.js